import { render, staticRenderFns } from "./hujiang.vue?vue&type=template&id=44198c32"
import script from "./hujiang.vue?vue&type=script&lang=js"
export * from "./hujiang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports